import { render } from "./AddPlaylistModal.vue?vue&type=template&id=04d9f5ba"
import script from "./AddPlaylistModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPlaylistModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/AddPlaylistModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04d9f5ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04d9f5ba', __exports__)) {
    api.reload('04d9f5ba', __exports__)
  }
  
  module.hot.accept("./AddPlaylistModal.vue?vue&type=template&id=04d9f5ba", () => {
    api.rerender('04d9f5ba', render)
  })

}


export default __exports__